import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { Filters } from 'libs/form';

const d = moment();
const initialFlt = {
  // status: 'active',
  timestamp_from: d.startOf('day').format(),
  timestamp_to: d.endOf('day').format(),
};

const Filter = ({ handleSubmit, reset, type, change, filter }) => {
  const { t } = useTranslation();

  const filters = [
    { type: 'doubledate', name: 'timestamp', title: t('grid.Дата и время'), change },
    { type: 'input', name: 'message', title: t('inputs.Описание'), placeholder: t('inputs.Введите название'), w: 230 },
    { type: 'dict', dict: 'events.type', multiple: true },
    { type: 'source', multiple: true, parkingIdLocal: filter ? filter.parking_id : '' },
    { type: 'parking' },
  ];

  return <Filters items={filters} page={type} handleSubmit={handleSubmit} reset={reset} t={t} />;
};

export default reduxForm({
  form: 'eventsFilter',
  destroyOnUnmount: false,
  initialValues: initialFlt,
})(Filter);
